import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";

import WelcomePage from "./WelcomePage";
import ScorePage from "./ScorePage";
import UserDetailsForm from "./UserFormPage";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<Router>
		<Routes>
			<Route path="/" exact Component={WelcomePage} />
			<Route path="/score" Component={ScorePage} />
			<Route path="/user-details" Component={UserDetailsForm} />
		</Routes>
	</Router>
);
